import { render, staticRenderFns } from "./SFormItem.vue?vue&type=template&id=6839f599"
import script from "./SFormItem.vue?vue&type=script&lang=js"
export * from "./SFormItem.vue?vue&type=script&lang=js"
import style0 from "./SFormItem.vue?vue&type=style&index=0&id=6839f599&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports